import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconLogout = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 6C12 6.55229 11.5523 7 11 7H8.33333C8.14924 7 8 7.14924 8 7.33333V16.6667C8 16.8508 8.14924 17 8.33333 17H11C11.5523 17 12 17.4477 12 18C12 18.5523 11.5523 19 11 19H8.33333C7.04467 19 6 17.9553 6 16.6667L6 7.33333C6 6.04467 7.04467 5 8.33333 5H11C11.5523 5 12 5.44771 12 6ZM13.9594 16.0404C13.5689 15.6498 13.5689 15.0167 13.9594 14.6261L15.5855 13H10C9.44772 13 9 12.5523 9 12C9 11.4477 9.44772 11 10 11H15.5857L13.9594 9.37369C13.5689 8.98317 13.5689 8.35 13.9594 7.95948C14.3499 7.56895 14.9831 7.56895 15.3736 7.95948L18.7069 11.2928C19.0975 11.6833 19.0975 12.3165 18.7069 12.707L15.3736 16.0404C14.9831 16.4309 14.3499 16.4309 13.9594 16.0404Z"
        />
      </svg>
    );
  }
);
